import React from 'react';
import Icon from '@pushpay/icon';
import { clsx, createUseStyles } from '@pushpay/styles';
import { ChMSTheme, isGivingOldTheme } from '@pushpay/theming';
const useStyles = createUseStyles(theme => ({
  root: {
    color: isGivingOldTheme(theme) ? '#003B8A' : ChMSTheme.colors['product-color-dark-200']
  }
}));

const InsightsIcon = ({
  classes: classesProp,
  className: classNameProp,
  ...rest
}) => {
  const classes = useStyles(classesProp);
  const className = clsx(classNameProp, classes.root);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24",
    className: className
  }, rest), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 24,
    height: 24,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.681 14.266c-2.832.066-4.863-1.487-5.524-2.271.777-.743 2.578-2.232 5.524-2.25 2.553-.017 4.597 1.493 5.3 2.25-.587.73-2.468 2.206-5.3 2.271z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.283 4.569c-.995 3.67.87 6.515 1.937 7.479 2.69-2.665 5.98-2.445 7.38-2.025-1.761-5.735-6.945-6.019-9.317-5.454z",
    fill: "#fff",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.213 19.422c-.998-3.634.873-6.472 1.944-7.427A7.74 7.74 0 0015.563 14c-1.768 5.68-6.97 5.981-9.35 5.422z",
    fill: "#fff",
    fillOpacity: 0.7
  }));
};

export default InsightsIcon;